<template>
    <div class="dropzone-file-container">
        <div class="dropzone-img-container" :style="{ backgroundImage: `url(${fileData})` }" />
        <div class="dropzone-file-details">
            <p class="font f-s-12">
                {{ file.name }}
            </p>
            <button type="button" @click="remove">
                Remove
            </button>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: process.browser ? [File, String, Object] : [String, Object],
            default: null,
        },
        index: {
            type: Number,
            required: true,
        },
        file: {
            required: true,
        },
    },
    data() {
        return {
            fileData: '',
        };
    },
    watch: {
        file() {
            this.readFileData();
        },
    },
    async beforeMount() {
        this.readFileData();
    },
    methods: {
        remove() {
            this.$emit('remove', this.index);
        },
        async readFileData() {
            this.fileData = await this.readFileAsync(this.file);
        },
        readFileAsync() {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();

                reader.onload = () => {
                    resolve(reader.result);
                };

                reader.onerror = reject;
                reader.readAsDataURL(this.file);
                // reader.readAsText(this.file);
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.dropzone-file-container {
    margin-bottom: 10px;
    display: flex;
    justify-content: space-between;
    .dropzone-img-container {
        width: 100px;
        min-width: 100px;
        height: 100px;
        background-size: cover;
        border-radius: 5px;
        border: 1px solid #ccc;
    }
    .dropzone-file-details {
        overflow: hidden;
        width: 100%;
        margin-left: 10px;
    }
}
</style>
